import React, { useEffect, useState } from "react";
import "./compare.css";

interface CompareToastProps {
  message: string;
  onClose: () => void;
  duration?: number;
}

const CompareToast: React.FC<CompareToastProps> = ({
  message,
  onClose,
  duration = 3000,
}) => {
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setClosing(true), duration - 300); // start slideOut a bit before remove
    const removeTimer = setTimeout(onClose, duration);
    return () => {
      clearTimeout(timer);
      clearTimeout(removeTimer);
    };
  }, [onClose, duration]);

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <div
        className={`
          bg-secondary text-secondary-foreground px-4 py-3 rounded-lg shadow-lg font-medium h-auto md:w-md w-[320px]
          transition-all
          ${
            closing
              ? "animate-[slideOut_0.3s_ease-in]"
              : "animate-[slideIn_0.3s_ease-out]"
          }
        `}
      >
        <h3 className="text-md font-bold text-black mb-2">
          Comparison Table
        </h3>

        {/* Dynamic message */}
        <p className="text-muted-foreground mb-2 text-sm">{message}</p>

        {/* Subtext */}
        <p className="text-xs text-primary">Please scroll below</p>
      </div>
    </div>
  );
};

export default CompareToast;
